// src/components/Community.js
import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom'; 
import './Community.css';
 
const Community = ({ user, userProfile }) => {
  const navigate = useNavigate();
  const sites = [
    {
      url: 'https://worldland.foundation',
      favicon: 'https://worldland.foundation/favicon.ico',
      fallbackIcon: '🏠',
      title: 'WorldLand Official Website',
      description: 'The official homepage of the WorldLand project. You can check project overview, roadmap, and team information.',
      label: 'WorldLand Foundation'
    },
    {
      url: 'https://explorer.worldland.foundation',
      favicon: 'https://explorer.worldland.foundation/favicon.ico',
      fallbackIcon: '🔍',
      title: 'WorldLand Explorer',
      description: 'Track all transactions, blocks, and addresses on the WorldLand blockchain in real-time.',
      label: 'WorldLand Explorer'
    },
    {
      url: 'https://wallet.worldlandcafe.com',
      favicon: 'https://wallet.worldland.foundation/favicon.ico',
      fallbackIcon: '👛',
      title: 'WorldLand Wallet',
      description: 'Securely manage your WorldLand tokens and interact with the blockchain ecosystem.',
      label: 'WorldLand Wallet'
    },
    {
      url: 'https://docs.worldland.foundation',
      favicon: 'https://docs.worldland.foundation/favicon.ico',
      fallbackIcon: '📚',
      title: 'WorldLand Documentation',
      description: 'Comprehensive technical documentation including API references, developer guides, and integration tutorials.',
      label: 'WorldLand Docs'
    },
    {
      url: 'https://cafe.naver.com/worldlandblockchain',
      favicon: 'https://cafe.naver.com/favicon.ico',
      fallbackIcon: '☕',
      title: 'WorldLand Naver Cafe',
      description: 'Join the Korean WorldLand community for discussions, support, and the latest updates.',
      label: 'WorldLand Cafe'
    },
    {
      url: 'https://discord.com/channels/1138697336856526868/1141963776145506334',
      favicon: 'https://discord.com/favicon.ico',
      fallbackIcon: '💬',
      title: 'WorldLand Discord Community',
      description: 'A space where WorldLand Discord community members communicate and share the latest news.',
      label: 'WorldLand Discord'
    }, 
    {
      url: 'https://marketplace.worldlandcafe.com',
      favicon: 'https://marketplace.worldland.foundation/favicon.ico',
      fallbackIcon: '🛒',
      title: 'WorldLand Marketplace',
      description: 'A marketplace where you can trade various digital assets within the WorldLand ecosystem. To be constructed.',
      label: 'https://marketplace.worldland.foundation'
    }, 
    {
      url: 'https://dao.worldland.foundation',
      favicon: 'https://dao.worldland.foundation/favicon.ico',
      fallbackIcon: '🏛️',
      title: 'WorldLand DAO',
      description: 'Join the WorldLand Decentralized Autonomous Organization. Participate in community governance, proposal creation, and decision-making processes.',
      label: 'https://dao.worldland.foundation'
    }, 
    {
      url: 'https://heungno.net/',
      favicon: 'https://heungno.net/favicon.ico',
      fallbackIcon: '👤',
      title: 'Heung-no Lee Personal Website',
      description: 'Personal website of Heung-no Lee, founder and key figure in the WorldLand project.',
      label: 'https://heungno.net/'
    },
    {
      url: 'https://libervance.com/',
      favicon: 'https://libervance.com/favicon.ico',
      fallbackIcon: '🔗',
      title: 'Libervance',
      description: 'Libervance - Related project or partner website connected to the WorldLand ecosystem.',
      label: 'https://libervance.com/'
    }
  ];

  const handleImageError = (e) => {
    e.target.style.display = 'none';
    if (e.target.nextElementSibling) {
      e.target.nextElementSibling.style.display = 'block';
    }
  };

  const handleBack = () => { 
      navigate('/'); 
  };

  return (
    <div className="community"> 
      <div className="community-header">
        {/* <div 
          onClick={handleBack}  
          className="common-back-button"
        >
          <ChevronLeft size={24} />
        </div> */}
        <h2 className="community-title">WorldLand Ecosystem</h2>
        <p className="community-subtitle">Collection of WorldLand Related Sites</p>
      </div>
      
      <div className="community-grid">
        {sites.map((site, index) => ( 
          <a
            key={index}
            href={site.url}
            target="_blank"
            rel="noopener noreferrer"
            className="community-card"
          >
            <div className="site-header">
              <div className="site-thumbnail">
                <img
                  src={site.favicon}
                  alt={site.title}
                  onError={handleImageError}
                />
                <span className="fallback-icon" style={{ display: 'none' }}>
                  {site.fallbackIcon}
                </span>
              </div>
              <div className="site-main-info">
                <h3 className="card-title">{site.title}</h3>
              </div>
            </div>
            <p className="card-description">{site.description}</p>
            <div className="site-url">{site.label}</div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Community;